import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Comment, CommentGroup } from "@/savaradio/common";

export const initialLoading = {
  create: false,
  delete: false,
  update: false,
  get: false,
  find: false
}

export type IsLoading = Record<keyof typeof initialLoading, boolean>;

const initialState: { value?: CommentGroup[], isLoading: IsLoading } = { isLoading: initialLoading }

const commentSlice = createSlice({
  name: "comment_slice",
  initialState,
  reducers: {
    append: (state, action: PayloadAction<Comment>) => {
      if (!state.value) state.value = [{
        _id: action.payload.client!,
        count: 1,
        comments: [action.payload]
      }]
      else {
        const target_comment_group = state.value.find(comment_group => comment_group._id === action.payload.client)
        if (
          target_comment_group &&
          !target_comment_group.comments.some(item => item._id === action.payload._id)
        ) {
          state.value = state.value.map(comment_group => {
            if (comment_group._id === target_comment_group._id) return {
              ...target_comment_group,
              count: target_comment_group.count + 1,
              comments: [...target_comment_group.comments, action.payload]
            }
            else return comment_group
          })
        }
        if (!target_comment_group) {
          state.value = [
            ...state.value,
            {
              _id: action.payload.client!,
              count: 1,
              comments: [action.payload]
            }
          ]
        }
      }
    },
    pop: (state, action: PayloadAction<Comment>) => {
      if (state.value) {
        const target_comment_group = state.value.find(comment_group => comment_group._id === action.payload.client)
        if (target_comment_group) {
          state.value = state.value.map(comment_group => {
            if (comment_group._id === target_comment_group._id) return {
              ...target_comment_group,
              count: target_comment_group.count - 1,
              comments: target_comment_group.comments.filter(comment => comment._id !== action.payload._id)
            }
            return comment_group
          })
        }
      }
    },
    merge: (state, action: PayloadAction<Comment>) => {
      if (state.value) {
        const target_comment_group = state.value.find(comment_group => comment_group._id === action.payload.client)
        if (target_comment_group) {
          state.value = state.value.map(comment_group => {
            if (comment_group._id === target_comment_group._id) return {
              ...target_comment_group,
              comments: target_comment_group.comments.map(comment => comment._id === action.payload._id ? action.payload : comment)
            }
            return comment_group
          })
        }
        else {
          state.value = state.value.map(comment_group => ({
            ...comment_group,
            comments: comment_group.comments.filter(comment => comment._id !== action.payload._id)
          })).concat([{
            _id: action.payload.client!,
            count: 1,
            comments: [action.payload]
          }])
        }
      }
    },
    reset: (state, action: PayloadAction<CommentGroup[] | undefined>) => {
      state.value = action.payload
    },
    setLoading: (s, action: PayloadAction<Partial<IsLoading>>) => {
      s.isLoading = {
        ...s.isLoading,
        ...action.payload
      }
    }
  }
})

export const { append, pop, merge, reset, setLoading } = commentSlice.actions

export const comment_slice = commentSlice.reducer